import React from 'react'
import {Sparkles, Check, Star} from 'lucide-react'
import HeroUrgencyBadge from '@/components/HeroUrgencyBadge'

function Hero() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <section className="relative bg-[#FCFAF5] overflow-hidden bread-texture">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="grid md:grid-cols-[45%_55%] gap-12 items-center">
          {/* Texto ~45% */}
          <div className="animate-fade-up space-y-6 order-2 md:order-1">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#EBD9C3] rounded-full text-[#49352B] text-sm font-semibold">
              FORNO ESSENCIAL®
            </div>

            <h1 className="font-display text-[#49352B] text-4xl md:text-6xl font-bold leading-[1.1]">
              Volte a sentir o cheiro de pão quentinho saindo do forno,{' '}
              <span className="text-[#D9891B]">sem abrir mão da sua saúde</span>
            </h1>

            <p className="text-lg md:text-xl text-[#49352B]/80 leading-relaxed max-w-lg">
              É possível voltar a comer pão, pizza, croissants e sobremesas com sabor de verdadeira padaria através do{' '}
              <span className="font-semibold text-[#5E774B]">Método Massa Perfeita™</span>, sem glúten,
              sem açúcar refinado e sem lactose.
            </p>

            <div className="flex flex-wrap items-center gap-x-5 gap-y-2 pt-1">
              {['+400 receitas', 'Sem glúten', 'Sem açúcar refinado', 'Sem lactose'].map((t, i) => (
                <span key={i} className="flex items-center gap-1.5 text-sm font-medium text-[#49352B]/75">
                  <Check className="w-4 h-4 text-[#5E774B]" />
                  {t}
                </span>
              ))}
            </div>

            <div className="pt-2">
              <HeroUrgencyBadge />
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-2">
              <button
                onClick={scrollToOffer}
                className="h-[69px] px-10 bg-[#D9891B] hover:bg-[#c17a15] text-white text-lg font-semibold rounded-[18px] transition-all duration-300 transform hover:scale-[1.06] shadow-[0_20px_40px_-10px_rgba(217,137,27,0.5)] hover:shadow-[0_24px_48px_-8px_rgba(217,137,27,0.65)] flex items-center justify-center gap-2"
              >
                <Sparkles className="w-5 h-5" />
                QUERO VOLTAR A COMER PÃO DE VERDADE
              </button>
            </div>

            <div className="flex flex-wrap items-center gap-x-5 gap-y-2 pt-1 text-sm text-[#49352B]/60">
              <span className="flex items-center gap-1 font-semibold text-[#49352B]">
                {Array.from({ length: 5 }).map((_, j) => (
                  <Star key={j} className="w-3.5 h-3.5 fill-[#D9891B] text-[#D9891B]" />
                ))}
                <span className="ml-1">4,9/5</span>
              </span>
              <span className="hidden sm:inline text-[#49352B]/30">•</span>
              <span>+15.000 famílias atendidas</span>
              <span className="hidden sm:inline text-[#49352B]/30">•</span>
              <span>+400 receitas testadas</span>
              <span className="hidden sm:inline text-[#49352B]/30">•</span>
              <span>Pagamento 100% seguro</span>
            </div>
          </div>

          {/* Imagem ~55% */}
          <div className="relative order-1 md:order-2 animate-fade-up">
            <div className="relative rounded-[20px] overflow-hidden shadow-2xl">
              <img
                src="https://static.lumi.new/c5/c533f1aeaf75b513a2f556bb217493d4.png"
                alt="Especialista culinária do Forno Essencial com aplicativo de receitas"
                className="w-full h-[420px] md:h-[560px] object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
